import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import SecurityInfoCreateDialog from 'routes/SecurityInfo/containers/SecurityInfoCrateDialog';
import CfFtpInfoCreateDialog from '../CfFtpInfo/containers/CfFtpInfoCreateDialog';
import { CF_ROUTE } from '../../constants';
import CollectionFunctionList from './containers/CollectionFunctionList';
import CollectionFunctionCreate from './containers/CollectionFunctionCreate';
import CollectionFunctionEdit from './containers/CollectionFunctionEdit';
import CollectionFunctionView from './containers/CollectionFunctionView';
import CollectionFunctionCopy from './containers/CollectionFunctionCopy';
import NetworkCreateDialog from '../Network/containers/NetworkCreateDialog';

interface Props {}

const CollectionFunction: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={CF_ROUTE}>
        <CollectionFunctionList />
      </Route>
      <Route exact path={`${CF_ROUTE}/create`}>
        <CollectionFunctionCreate />
      </Route>
      <Route exact path={`${CF_ROUTE}/edit`}>
        <CollectionFunctionEdit />
      </Route>
      <Route exact path={`${CF_ROUTE}/view`}>
        <CollectionFunctionView />
      </Route>
      <Route exact path={`${CF_ROUTE}/copy`}>
        <CollectionFunctionCopy />
      </Route>
      <NetworkCreateDialog />
      <SecurityInfoCreateDialog />
      <CfFtpInfoCreateDialog />
    </Fragment>
  );
};

export default CollectionFunction;
